export default function getPossibleTypes(unionObjectTypesMap) {
    const output = {};
    Object.entries(unionObjectTypesMap).forEach(([typename, paths])=>{
        output[typename] = Array.from(new Set(Object.values(paths).flat()));
    });
    return output;
}

//# sourceMappingURL=getPossibleTypes.js.map